module.exports = __webpack_public_path__ + "images/contact/saubere_filme_kontakt_foto.jpg";